<template>
    <div class="list_mem_create">
        <div class="panel-container show" v-if="!work_obj.isLoaded">
            <div class="panel-content">
                <b-overlay key="feed_loader" :show="work_obj.isRunning" rounded="sm">
                    <template v-slot:overlay>
                        <div class="text-center">
                            <p id="cancel-label">{{ __t('LOADING') }} <span v-html="work_obj.step_name"></span></p>
                            <p>
                                <b-badge variant="primary" pill v-if="work_obj.isRunning">{{ __t('LOADING') }}...
                                    {{ timer.seconds }} сек
                                </b-badge>
                            </p>
                            <b-button ref="Отмена" variant="danger" size="sm" @click="cancel_load">
                                {{ __t('CANCEL') }}
                            </b-button>
                        </div>
                    </template>

                    <!-- DEMO -->
                    <b-list-group-item variant="primary" v-if="work_obj.isRunning">
                        {{ __t('RESTAURANTS') }}
                    </b-list-group-item>

                    <b-list-group-item variant="primary" v-if="work_obj.isRunning">
                        {{ __t('PAYMENTS') }}
                    </b-list-group-item>
                    <b-list-group-item variant="primary" v-if="work_obj.isRunning">
                        {{ __t('CATEGORIES') }}
                    </b-list-group-item>
                    <b-list-group-item variant="primary" v-if="work_obj.isRunning">
                        {{ __t('PRODUCTS') }}
                    </b-list-group-item>
                </b-overlay>
            </div>
        </div>

        <div class="panel-container show" v-if="work_obj.isLoaded">
            <div class="panel-content">
                <table class="table table-stripped" v-if="work_obj.isLoaded">
                    <thead>
                    <tr>
                        <th width="35px">#</th>
                        <th>{{ __t('FEED_TYPE') }}</th>
                        <th>{{ __t('FEED_QTY') }}</th>
                        <th>{{ __t('FEED_STATUS') }}</th>
                    </tr>
                    </thead>

                    <tbody>
                    <template v-for="(item_feed,type) in this.feed">
                        <tr>
                            <td>
                                {{ item_feed.number }}
                            </td>

                            <td>
                                {{ __t(item_feed.human_name) }}
                            </td>

                            <td>
                                <b-badge variant="success">
                                    {{ item_feed.count_ok }}
                                </b-badge>
                                /
                                <b-badge variant="danger">
                                    {{ item_feed.count_err }}
                                </b-badge>
                                /
                                <b-badge variant="info">
                                    {{ item_feed.count_all }}
                                </b-badge>

                            </td>
                            <td>
                                {{ item_feed.status }}
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>

            <div class="buttons mt-5 p-5">
                <button class="btn btn-lg btn-outline-primary waves-effect waves-themed"
                        v-on:click="sync_menu"
                        :disabled=can_sync>
                        <span class="fal"
                              :class="{'fa-check mr-1' : !can_sync, 'fa-exclamation-triangle' : can_sync}">
                        </span>
                    {{__t('CONTINUE')}}
                </button>

                <button class="btn btn-lg btn-outline-warning waves-effect waves-themed ml-5"
                        v-on:click="go_start"
                        :disabled=!can_sync>
                        <span class="fal"
                              :class="{'fa-check mr-1' : can_sync, 'fa-exclamation-triangle' : !can_sync}">
                        </span>
                    {{__t('BACK')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "pos_sync_feed",
    props : {
        selected_org : {
            type : String,
            required : true,
        },

        external_menu_id : {
            type : String | Number,
            default : 0
        },

        child_organizations : {
            type :Array,
            default: () => []
        }
    },
    data() {
        return {
            options: {
                batchSize: 3,
                retry: false
            },

            timer: {
                seconds: 0,
                interval: null,
            },

            work_obj: {
                step_name: "",
                isRunning: false,
                isSyncRun:false,
                isSynced: false,
                isLoaded: false,
                isFileFeed  : false,
                request_cancel: null,
                token: null,
                is_in_socket : false,
            },
            feed: [],
        }
    },
    created() {
        this.get_params();
        EventBus.$on('provider_task_' + this.prov_id,this.operate_socket_task)
    },

    methods: {

        operate_socket_task(event) {
            console.log('operate_feed_socket', event);

            if (!event.hasOwnProperty("status")) {
                console.warn("Invalid event structure:", event);
                return;
            }

            let { step: task_step, status: task_status, task_id, err = "unknown error", extra_data } = event;
            this.work_obj.step_name = `<br> MENU_STEP: ${task_step.toUpperCase()} <br>STATUS: ${task_status.toUpperCase()} <br>TaskId: ${task_id}`;

            switch (task_status) {
                case 'operation_fail':
                    this._count_stop();
                    EventBus.$emit('show_toast', {
                        err: err,
                        type: "danger",
                        title: this.__t("ERR_WORK_GET_FEED"),
                    });
                    break;

                case 'operation_success':
                    if (task_step === 'finish' && extra_data?.response) {
                        this.feed = extra_data.response;
                        this.work_obj.isLoaded = true;
                        this.work_obj.isRunning = false;
                        this.close_task(task_id);
                    }
                    break;

                default:
                    console.warn("Unhandled task status:", task_status);
            }
        },

        get_params() {

            let self = this;
            this.work_obj.isRunning = true;
            this._count_start();
            this.work_obj.step_name = 'INIT';
            this.feed = [];

            if(this.is_debug) {
                this
                    .get_feed()
                    .then(({data}) => {
                        self.__l(data, "info", "token");
                        if (data.status === "operation_success") {
                            self.feed = data.data;
                            self.work_obj.isLoaded = true;
                            self.work_obj.isRunning = false;
                        } else {
                            throw ("cant get feed");
                        }
                    }).catch(({response}) => {
                    console.log(response);
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                    })
                });
            }
            else {
                this.push_task().then(({data}) => {
                    console.log('TASK_CREATED', data);
                }).catch(({response}) => {
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                    });
                });
            }
        },

        async get_feed() {
            this.work_obj.request_cancel = api.CancelToken;
            let url = '/pos/' + this.prov_id + '/organizations/' + this.selected_org + "/feed";

            const extraParams = {
                ...(this.pos_item.pos_params?.extra_request || {}),
                child_ids: this.child_organizations,
                external_menu_id: this.external_menu_id,
            };

            return await pos_api.post(url,{
                'child_ids'         : this.child_organizations,
                "external_menu_id"  : this.external_menu_id,
                'extra_params'      : extraParams
            },{
                cancelToken: this.work_obj.request_cancel.token
            });
        },

        async push_task() {

            const extraParams = {
                ...(this.pos_item.pos_params?.extra_request || {}),
                child_ids: this.child_organizations,
                external_menu_id: this.external_menu_id,
            };

            return pos_api.put('/pos/' + this.prov_id + '/task',{
                "main_org_id"       : this.selected_org,
                'child_ids'         : this.child_organizations,
                'external_menu_id'  : this.external_menu_id,
                'extra_params'      : extraParams
            })
        },

        async close_task(task_id) {
            await pos_api.patch('/pos/' + this.prov_id + '/task/' + task_id);
        },

        async remove_task() {
            await pos_api.delete('/pos/' + this.prov_id + '/task').then(({data}) => {
                if(data.status == "operation_success") {
                    this.work_obj.is_in_socket = false;
                }
            });
        },

        sync_menu() {
            let self = this;
            self.work_obj.isRunning = true;

            // Create a promise to start the chain
            let promise = Promise.resolve('OK');
            for (const [key, value] of Object.entries(self.feed)) {
                promise = promise.then((res) => {
                    return self.build_promise(key,value)
                });
            }

            promise.catch((response) => {
                self.work_obj.isRunning = false;
                EventBus.$emit('show_toast', {
                    err: "ERR",
                    type: "danger",
                    title: "operation_fail"
                })
            });
            promise.then((response) => {
                console.log('finish',response);
                EventBus.$emit('show_toast', {
                    err: "OK",
                    type: "success",
                    title: "Finish"
                })
            })
        },

        unmark_old(type) {
            return pos_api.patch('/pos/' + this.prov_id + '/organizations/' + this.selected_org + "/" + type, {
                'type' : type,
            });
        },

        build_promise(idx,item)
        {
            let self = this;
            return this.unmark_old(idx).then((res) => {
                self.feed[idx].status = 'working';
                return this.make_batch(idx);
            }).then((res) => {
                console.log(res);
                self.feed[idx].status = 'finish';
                return res;

            }).catch((response) => {
                console.log('chain_err',response);
                self.feed[idx].status = 'error';
                EventBus.$emit('show_toast', {
                    err: "ERR:" + idx,
                    type: "danger",
                    title: "operation_fail"
                })

                throw new Error(response);
            });
        },

        async batchAxiosPromises(_items, cur_feed ,fn, callback) {
            let promiseChainResult = Promise.resolve();
            let self = this;
            let chunked_items = _items.chunk_inefficient(
                this.options.batchSize
            );
            let promiseChain = Promise.resolve();

            chunked_items.map(function (entity) {
                function getCurrentItem(item) {
                    return fn(item,cur_feed)
                        .then(({data}) => {
                            self.__l(item, "info", "SuccessFN -> Done");
                            if (callback != null) {
                                callback("OK");
                            }
                        }).catch(err => {
                            self.__l(item, "warn", "ErrorFN -> ERR");
                            if (callback != null) {
                                callback("ERR");
                            }
                        })
                }

                const makeNextPromise = (entity) => () => {
                    const allPromises = entity.map(item => getCurrentItem(item));
                    return Promise.all(allPromises).then(res => {
                        self.__l({}, "ok", "Chunk -> Done")
                    });
                };
                promiseChain = promiseChain.then(makeNextPromise(entity))
            });
            return promiseChain;
        },

        make_batch(idx) {
            let self = this;
            let cur_feed = self.feed[idx];
            return this.batchAxiosPromises(cur_feed.items, cur_feed, this.put_feed_item, res => {
                this.__l(res, "ok", "SYNC  -> " + idx);
                if (res === "OK") {
                    cur_feed.count_ok++;
                } else {
                    cur_feed.count_err++;
                }
            });
        },

        go_start() {
            window.location.reload();
        },

        async put_feed_item(item,cur_feed) {
            console.log(cur_feed);
            let cur_type = cur_feed.cur_type;
            cur_type = cur_type.slice(0,-1);

            if(cur_type == 'categorie') {
                cur_type = 'category';
            }

            if(cur_type == 'citie') {
                cur_type = 'city';
            }

            if(cur_type == 'organization') {
                return pos_api.put('/pos/' + this.prov_id + '/organization', {
                    "store_item": item,
                });
            }

            //For Debugging
            if(cur_type == 'product' && this.prov_id == 12) {
                return pos_api.put('/pos/' + this.prov_id + '/organizations/' + this.selected_org +"/"+ cur_type + '/' + item.id, {
                    "store_item": item,
                });
            }

            return pos_api.put('/pos/' + this.prov_id + '/organizations/' + this.selected_org +"/"+ cur_type, {
                "store_item": item,
            });
        },

        _count_start() {
            this.timer.interval = setInterval(this.incrementTime, 1000);
        },

        incrementTime() {
            this.timer.seconds = parseInt(this.timer.seconds) + 1;
            if(this.timer.seconds > 600) {
                this.cancel_load();

            }
        },

        _count_stop() {
            clearInterval(this.timer.interval);
        },

        cancel_load() {
            this._count_stop();
            this.work_obj.isRunning = false;
            this.work_obj.isRunning = false;
            this._feed = [];
            if(this.work_obj.is_in_socket) {
                this.remove_task();
            }
        },
    },
    computed: {
        can_sync() {
            if (this.work_obj.isRunning) {
                return true;
            }

            return !this.has_active_org;
        },

        has_active_org() {
            return this.selected_org.length > 0;
        },

        has_menu() {
            return this.feed.hasOwnProperty("products");
        },

        prov_id () {
            return parseInt(this.provider.id);
        },


        client_id () {
            return this.user.client_id;
        },

        provider () {
            if(this.pos_item.hasOwnProperty('provider')) {
                return this.pos_item.provider;
            }
            return null;
        },

        ...mapGetters({
            'pos_item': "pos/getPos",
            'is_load' : "pos/is_load",
            'user'    : 'user/getUser',
            'is_debug' : 'user/is_debug'
        }),
    }
}
</script>

<style scoped>

</style>
